import React from 'react';
import IconWrapper from '../IconWrapper';
const CheckmarkerIcon = (props) => {
    const brand = process.env.BRAND || process.env.BRAND_PREFIX;
    switch (brand) {
        case 'northstar':
            return (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "0 0 16 16" }),
                React.createElement("path", { d: "m5.5 12.44 8.97-8.97 1.06 1.06L5.5 14.562.47 9.53l1.06-1.06 3.97 3.97Z" })));
        default:
            return (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "0 0 16 16" }),
                React.createElement("path", { d: "M5.938 12.979L5.92 13l-.002-.001V13l-.02-.018L2 9.762 2.653 9l3.19 2.635L13.263 4l.737.684-8.062 8.295z" })));
    }
};
export default CheckmarkerIcon;
//# sourceMappingURL=CheckmarkerIcon.js.map